import { render, staticRenderFns } from "./InputDate.vue?vue&type=template&id=1be525bb&"
import script from "./InputDate.vue?vue&type=script&lang=js&"
export * from "./InputDate.vue?vue&type=script&lang=js&"
import style0 from "./InputDate.vue?vue&type=style&index=0&id=1be525bb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports